/*
 * @Author: your name
 * @Date: 2021-03-30 22:10:31
 * @LastEditTime: 2022-03-22 22:33:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\router\index.js
 */
import Vue from "vue";
import store from "@/store/index";
import VueRouter from "vue-router";
// import { check_login } from '@/api/userAPI';

/**
 * 重写路由的push方法
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: "/",
            name: "Index",
            component: () => import("@/page/Index.vue"),
        },
        {
            path: "/GoodList",
            name: "GoodList",
            component: () => import("@/page/GoodList.vue"),
        },
        {
            path: "/Search",
            name: "Search",
            component: () => import("@/page/Search.vue"),
        },
        {
            path: "/Good",
            name: "Good",
            component: () => import("@/page/Good.vue"),
        },
        {
            path: "/Leaderboard",
            name: "Leaderboard",
            component: () => import("@/page/Leaderboard.vue"),
        },
        {
            path: "/Login",
            name: "Login",
            component: () => import("@/page/Login.vue"),
        },
        {
            path: "/verify",
            name: "Verify",
            component: () => import("@/page/Verify"),
        },
        {
            path: "/Center",
            name: "Center",
            component: () => import("@/page/Center.vue"),
            meta: {
                loginKeep: true,
            },
        },
        {
            path: "/Cart",
            name: "Cart",
            component: () => import("@/page/Cart.vue"),
            meta: {
                loginKeep: true,
            },
        },
        {
            path: "/UserInfo",
            name: "UserInfo",
            component: () => import("@/page/UserInfo.vue"),
            meta: {
                loginKeep: true,
            },
        },
        {
            path: "/Password",
            name: "Password",
            component: () => import("@/page/Password.vue"),
            meta: {
                loginKeep: true,
            },
        },
        {
            path: "/OrderList",
            name: "OrderList",
            component: () => import("@/page/OrderList.vue"),
            meta: {
                loginKeep: true,
            },
        },
        {
            path: "/MyPrice",
            name: "MyPrice",
            component: () => import("@/page/MyPrice.vue"),
            meta: {
                loginKeep: true,
            },
        },
    ],
    mode: "history",
    base: process.env.BASE_URL,
});

// 每个路由进入之前会触发beforeEach(去哪个路由, 从哪个路由过来，【函数】通过该函数跳转指定路由)函数
// 如果没增加next函数，则页面所有路由都不会跳转
router.beforeEach(async (to, from, next) => {
    // 判断是否需要登录访问，mate在路由配置里面设置
    if (to.meta.loginKeep) {
        // 判断是否已经登录
        if (store.state.loginUser.user_data) {
            next();
        } else {
            var res = await router.app.$store.dispatch("loginUser/check_login");

            if (res) {
                // 已经登录完成，已经有数据了
                next();
            } else {
                next({ name: "Login" });
            }
        }
    } else {
        // 直接访问
        // 判断是否有token，有的话，验证登录
        if (localStorage.getItem("token")) {
            await router.app.$store.dispatch("loginUser/check_login");
        }
        next();
    }
});

export default router;
